export default {
  hero: {
    badge: 'AllChinaBuy Spreadsheet ressourcehub',
    title: 'AllChinaBuy Spreadsheet – Find produkter, sammenlign og køb smartere',
    subtitle: 'Udforsk AllChinaBuy Spreadsheet ét organiseret sted. Opdag produktfund, populære kategorier, QC-guider, forsendelsesinfo, anmeldelser og praktiske købsressourcer.',
    ctaPrimary: 'Udforsk AllChinaBuy Spreadsheet',
    ctaSecondary: 'Se populære fund',
    mainCta1: 'allchinabuy spreadsheet',
    mainCta2: 'køb nu',
  },
  search: {
    label: 'Søg i AllChinaBuy Spreadsheet',
    placeholder: 'Søg kategorier, guider, anmeldelser...',
    categoryLabel: 'Gennemse efter kategori',
    selectPlaceholder: 'Vælg en kategori',
    go: 'Gå til kategori',
  },
  categories: {
    title: 'Populære kategorier',
    subtitle: 'Gå direkte til de produkter, du interesserer dig for. Hver kategori åbner på hoved-AllChinaBuy-spreadsheetet.',
  },
  guides: {
    title: 'Guides og ressourcer',
    subtitle: 'Praktiske gennemgange der dækker kvalitetskontrol, forsendelse, anmeldelser og sikker køb.',
  },
  featured: {
    title: 'Udvalgte fund',
    subtitle: 'Et kig på de produkter, folk oftest gemmer i deres regneark.',
    items: [
      { title: 'Holdbare hverdagssneakers', body: 'Rene silhuetter og solide materialer gør disse til et gentaget valg på mange købslister.' },
      { title: 'Bokset streetwear-hoodies', body: 'Tung bomuld og oversize-pasform dominerer hoodie-sektionen i regnearket.' },
      { title: 'Minimalistiske logo-tees', body: 'Enkle, alsidige t-shirts, der er nemme at style og holder budgettet.' },
      { title: 'Utility-jakker og overtøj', body: 'Tekniske stoffer og afslappede snit, der fungerer hele året.' },
    ],
  },
  qc: {
    title: 'QC-guide',
    subtitle: 'Sådan læser du kvalitetskontrolbilleder, før du sender.',
    body: 'Før dine varer forlader lageret, skal du nøje gennemgå QC-billederne. Tjek syninger, farvenøjagtighed, logo-placering og mål i forhold til størrelsesguiden.',
  },
  shipping: {
    title: 'Forsendelsesguide',
    subtitle: 'Forstå dine forsendelsesmuligheder og omkostninger.',
    body: 'Sammenlign forsendelseslinjer efter hastighed, pris og pålidelighed. Tungere eller større varer koster ofte mere, så at samle et helt haul sparer ofte penge.',
  },
  review: {
    title: 'AllChinaBuy-anmeldelse',
    subtitle: 'Et ærligt blik på, hvordan det fungerer.',
    body: 'Fra bestilling til sporing af en pakke – lær hvad du kan forvente, hvor servicen er stærk, og hvad du skal være opmærksom på.',
  },
  safety: {
    title: 'Sikkerhedscenter',
    subtitle: 'Køb med ro i sindet.',
    body: 'Tips til kontosikkerhed, sikker betaling, undgåelse af forfalskninger og forståelse af told og begrænsede produkter.',
  },
  articles: {
    title: 'Seneste artikler',
    subtitle: 'Dybdegående guider og ærlige beskrivelser, der hjælper dig med at købe smartere.',
    readMore: 'Læs artikel',
    viewAll: 'Se alle artikler',
  },
  faq: {
    title: 'Ofte stillede spørgsmål',
    subtitle: 'Hurtige svar på de mest almindelige spørgsmål.',
    items: [
      { q: 'Hvad er AllChinaBuy Spreadsheet?', a: 'Det er en organiseret samling af produktfund, kategorier og købsressourcer, der hjælper dig med at opdage og sammenligne varer før køb.' },
      { q: 'Er AllChinaBuy legitimt?', a: 'Verificér altid de aktuelle politikker selv. Vores guider hjælper dig med at forstå processen, men du bør gennemgå vilkår, sælgerbedømmelser og lokale regler før bestilling.' },
      { q: 'Hvor meget koster forsendelse?', a: 'Forsendelsesomkostninger afhænger af vægt, størrelse, destination og den valgte forsendelseslinje. At samle varer i én pakke reducerer ofte totalen.' },
      { q: 'Hvordan læser jeg QC-billeder?', a: 'Tjek syninger, farver, logoer og mål i forhold til annoncen og størrelsesguiden. Meld enhver uoverensstemmelse, før varerne sendes.' },
    ],
  },
  cta: {
    title: 'Klar til at udforske hele regnearket?',
    subtitle: 'Besøg hovedwebstedet for at gennemse hver kategori og finde dit næste favoritfund.',
    button: 'Besøg hovedwebstedet',
  },
};